import { combineReducers } from "redux";

import GeneralReducer from "./general.reducer";
import UserReducer from "./user.reducer";
import RegionReducer from "./region.reducer";
import PropertyReducer from "./property.reducer";

export default combineReducers({
  general: GeneralReducer,
  user: UserReducer,
  region: RegionReducer,
  property: PropertyReducer
});
